import { useStore } from '../state/store';
import { BankArea } from './BankArea';
import { Badge, Card, CardBody } from '../design/primitives';

/**
 * Retail support.
 *
 * The ticket list is where the injection scenario lives, so tickets are rendered
 * as their full text rather than summarised. The audience needs to be able to
 * read the attack for themselves — being told "this one contains an injection"
 * is far less convincing than seeing the paragraph a customer actually wrote.
 */
export function Retail() {
  const { bootstrap } = useStore();
  if (!bootstrap) return null;
  const { tickets, customers } = bootstrap.records;

  const nameOf = (customerId: string) =>
    customers.find((customer: any) => customer.id === customerId)?.name ?? customerId;

  return (
    <BankArea
      serverName="retail-support-mcp"
      lede="A support assistant reads customer tickets and answers them. Tickets are written by members of the public, which makes them untrusted input — the assistant treats their contents as data, never as instructions."
    >
      <section>
        <h2 className="mb-section-title">Support queue</h2>
        <p className="mb-section-sub">
          Everything below was written by a customer. Read them before running the injection scenario — one of these is
          not a support request.
        </p>
        <div className="mb-ticket-list">
          {tickets.map((ticket: any) => (
            <Card key={ticket.id}>
              <CardBody>
                <div className="mb-ticket__head">
                  <code className="mb-mono">{ticket.id}</code>
                  <strong className="mb-grow">{ticket.subject}</strong>
                  <Badge tone="neutral" glyph={false}>
                    {ticket.channel}
                  </Badge>
                  <Badge tone={ticket.status === 'open' ? 'approval' : 'allow'}>{ticket.status}</Badge>
                </div>
                <div className="mb-ticket__meta">
                  {nameOf(ticket.customerId)} · opened {ticket.openedAt}
                </div>
                <pre className="mb-ticket__body">{ticket.body}</pre>
              </CardBody>
            </Card>
          ))}
        </div>
      </section>
    </BankArea>
  );
}
